import axios from "axios";
import NProgress from "nprogress";
import router from '../router/Router';
import { loadingState } from "./LoadingState";
import { destruirAlerta } from '../utils/Utils';

let validandoSesion = false;
let promesaValidacion = null;
let abortController = new AbortController();
const API_BASE = (process.env.VUE_APP_URL || "").replace(/\/$/, "");

const axiosRequest = axios.create({
  //baseURL: localStorage.getItem("servidor") + "/asincrona",
  //baseURL: "/asincrona",
  baseURL: `${API_BASE}/asincrona`,
  headers: {
    "Content-type": "application/json",
    "Access-Control-Allow-Origin": "*",
    'X-Crypto-Version': '2',
  },
});

const axiosValidacion = axios.create({
  baseURL: `${API_BASE}/asincrona`,
  headers: { "Content-Type": "application/json", 'X-Crypto-Version': '2', }
});

axiosValidacion.interceptors.request.use(config => {
  config.showLoader = false;
  return config;
});



axiosRequest.interceptors.request.use((config) => {
  // Endpoints previos a la autenticación: nunca deben llevar un Bearer token.
  // Si quedó un token viejo/expirado en sessionStorage (ej. de una sesión
  // anterior no cerrada correctamente), el backend lo valida antes de revisar
  // las credenciales y rechaza el login con 401 aunque el usuario/contraseña
  // sean correctos.
  const esEndpointPreAuth = /\/api\/auth\/(login|existe-usuario)(\?|$)/.test(config.url || "");
  const token = sessionStorage.token;
  if (token && !esEndpointPreAuth) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  config.signal = abortController.signal;

  if (config.showLoader !== false) {
    NProgress.start()
    loadingState.isLoading = true;
  }

  return config;
},
  (error) => {
    NProgress.done();
    loadingState.isLoading = false;
    return Promise.reject(error);
  }
);


axiosRequest.interceptors.response.use(
  (response) => {
    if (response.config.showLoader !== false) {
      NProgress.done();
      loadingState.isLoading = false;
    }
    return response;
  },
  async (error) => {
    if (error.config?.customTag === "verificaAcceso") {
      cerrarSesion();
    }

    if (error.config && error.config.showLoader !== false) {
      NProgress.done();
      loadingState.isLoading = false;
    }

    const status = error.response?.status;
    //TOKEN EXPIRADO / INVALIDO
    if (status === 401 || status === 403) {
      cerrarSesion();
      throw error;
    }

    // NETWORK ERROR (CORS, backend caído, timeout)
    if (!error.response && !validandoSesion) {
      validandoSesion = true;

      const sigueValido = await validarTokenActivo();

      validandoSesion = false;

      if (!sigueValido) {
        cerrarSesion();
      }
    }

    throw error;
  }
);


async function validarTokenActivo() {
  if (promesaValidacion) return promesaValidacion;

  promesaValidacion = await (async () => {
    const token = sessionStorage.token;
    if (!token) return false;

    try {
      const resp = await axiosValidacion.post(`${API_BASE}/api/auth/validar-token`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return resp.data === true;
    } catch (e) {
      // Si el servidor está caído o hay error de red, 
      // decidimos si queremos cerrar sesión o no. 
      // Usualmente, si no hay red, devolvemos false para proteger la app.
      console.error("Error al validar el token activo: ",e)
      return false;
    } finally {

      promesaValidacion = null;
    }
  })();

  return promesaValidacion;
}


function cerrarSesion() {

  //Cancela TODAS las peticiones pendientes
  abortController.abort();
  abortController = new AbortController(); // crear uno nuevo para futuras sesiones

  sessionStorage.clear();
  localStorage.clear();
  localStorage.removeItem("tokenSesion");
  localStorage.removeItem("servidor");
  localStorage.removeItem("aciqui_instance");

  delete axiosRequest.defaults.headers.Authorization;
  destruirAlerta();
  if (router.currentRoute.name !== "Login") {
    router.replace({ name: "Login" });
  }
}


export default axiosRequest;